// Libs
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Utils
import {
  clearOwnerSession,
  getOwnerToken,
  isAuthStuck,
  isSessionExpired,
} from '@app/utils/ownerAuth';

// Nếu đã có token owner CÒN HẠN mà đang ở màn login → chuyển vào `path`.
// Token-based, KHÔNG ping :3865 (luồng owner đã bỏ hẳn cổng auth cũ).
// Token quá hạn → dọn luôn tại đây, để người dùng đăng nhập lại thay vì bị đá
// vào dashboard rồi văng ngược ra khi API trả 401.
const useAuthRedirect = (path) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Người dùng CHỦ ĐỘNG về màn login (nút thoát của spinner chậm / khối lỗi
  // dashboard) — token có thể vẫn còn hạn, nhưng đá ngược họ vào dashboard là
  // đúng cái bẫy họ vừa tìm đường thoát ra.
  const forceLogin = Boolean(location?.state?.forceLogin);

  useEffect(() => {
    if (!getOwnerToken() || forceLogin) {
      return;
    }

    if (isSessionExpired()) {
      clearOwnerSession();
      return;
    }

    // BẪY ĐÃ TỪNG XẢY RA (13/08/2026): server coi token hết hạn nhưng FE tưởng còn
    // hạn (lệch giờ máy, đổi Jwt:Secret, 401 bị CORS chặn nên FE không biết). Khi đó
    // người dùng tự vào /auth/login sẽ bị dòng navigate() dưới đây đá NGƯỢC về
    // dashboard — dashboard lại gọi API thất bại → loading/lỗi vô hạn, KHÔNG CÁCH NÀO
    // đăng nhập lại. Có cờ "nghi hỏng" thì ở lại màn login để người dùng lấy token mới.
    if (isAuthStuck()) {
      return;
    }

    navigate(path, { replace: true });
  }, [navigate, path, forceLogin]);
};

export default useAuthRedirect;
